import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch";
import {activateMobileAmenityOverlay} from "@Reducers/mobileSlice";

export default function useCloseAmenityMobileOverlay() {
    const dispatch = useAppDispatch()

    const closeOverlay = () => {
        dispatch(activateMobileAmenityOverlay(null))
    }

    return {
        closeOverlay,
    }
}